import qs from 'query-string'

export function getSearchParams(_location) {
  const location = _location ?? window.location

  const params = qs.parse(location.search)

  return params
}
